import { render, staticRenderFns } from "./DownloadPanel.vue?vue&type=template&id=36f03681&scoped=true"
import script from "./DownloadPanel.vue?vue&type=script&lang=ts"
export * from "./DownloadPanel.vue?vue&type=script&lang=ts"
import style0 from "./DownloadPanel.vue?vue&type=style&index=0&id=36f03681&prod&lang=less"
import style1 from "./DownloadPanel.vue?vue&type=style&index=1&id=36f03681&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f03681",
  null
  
)

export default component.exports